module.exports = __webpack_public_path__ + "img/2.87119ef2.png";